<template>
  <div class="register-use">
    <div class="main-title">使用帮助/注册使用</div>
    <h1 class="page-title">注册使用</h1>
    <h4 class="content-text">1、首先提供手机号，平台审核注册后，直接进入松鼠互娱官网：<a href="https://bar.009bar.com/" target="_blank" rel="noopener noreferrer" class="link">https://bar.009bar.com/</a> 凭账号+密码登录。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-registeruse1_176828511533551dfee.webp"
      alt="账号密码登录松鼠互娱官网后台"
      class="example-image"
    />
    <h4 class="content-text">2、在首页，可以设置具体酒吧信息，包括：商家名称、商家地址、酒吧类型（三个必填项）以及其他选填项如图所示。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-registeruse2_176828511533560ea9d.webp"
      alt="编辑酒吧名称地址信息"
      class="example-image"
    />
    <h4 class="content-text">3、通过我的互动进入互动界面，在下方菜单栏，选择自己需要的游戏进行操作即可。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-registeruse3_1768285115335a08031.webp"
      alt="进行酒吧活动游戏设置"
      class="example-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-registeruse4_17682851153361711f1.webp"
      alt="进入酒吧大屏互动主页面"
      class="example-image"
    />
  </div>
</template>

<script>
export default {
  name: 'RegisterUse',
};
</script>

<style lang="less" scoped>
.register-use {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;

  .link {
    color: #E19BFF;
    text-decoration: none;

    &:hover {
      color: #E19BFF;
      text-decoration: underline;
    }

    &:visited {
      color: #E19BFF;
    }
  }
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
